// extracted by mini-css-extract-plugin
export default {"Header":"Header_Header__7mX-M","HeaderText":"Header_HeaderText__ubvGu","HeaderImage":"Header_HeaderImage__tq+ma"};